/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BannerClassStudentDropDownViewModel } from "../types/BannerClassStudentDropDownViewModel.ts";

export const bannerClassStudentDropDownViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID da matrícula (ClassStudent) da turma."),
  ),
  code: z.string().describe("Código da turma.").nullish(),
  name: z.string().describe("Descrição da turma.").nullish(),
  brandId: z
    .number()
    .int()
    .describe("ID da marca da turma. Nulo quando a turma não possui marca.")
    .nullish(),
  brandName: z
    .string()
    .describe("Nome da marca da turma. Nulo quando a turma não possui marca.")
    .nullish(),
}) as unknown as ToZod<BannerClassStudentDropDownViewModel>;
